import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import thunk from "redux-thunk";
import {Provider} from "react-redux";
import {createStore, applyMiddleware, combineReducers, compose} from "redux";
import {persistStore, persistReducer} from "redux-persist";
import storage from 'redux-persist/lib/storage'
import {PersistGate} from 'redux-persist/integration/react'
import user from "./redux/reducers/user.reducer";
import { GoogleOAuthProvider } from '@react-oauth/google';

const rootReducer = combineReducers({
    user

});

const persistConfig = {
    key: 'root',
    storage,
    blacklist: []
}
const middleware = [thunk];

const persistedReducer = persistReducer(persistConfig, rootReducer)

let store = createStore(
    persistedReducer,
    undefined,
    compose(
        applyMiddleware(...middleware)
    )
);
let persistor = persistStore(store)


ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <GoogleOAuthProvider clientId="301885312870-ovmh0isv54od6lhfubk7iv52kscg02hq.apps.googleusercontent.com">
            <App/>
          </GoogleOAuthProvider>

        </PersistGate>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
